module.exports = __webpack_public_path__ + "static/the-talent-behind-disney-communications-menu-ee4ed9d92f83f16cbe3d8e4dc26af0c4.jpg";